angular
    .module('empower.modules')
    .constant('setting', {
        
    });